import { Button } from "@/components/ui/Button";
import { Alert } from "@/components/ui/Alert";
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { Input } from "@/components/ui/Input";
import { useAppContext } from "@/context/AppContext";
import { useLanguage } from "@/context/LanguageContext";
import { useMenuItemsContext } from "@/context/MenuItemsContext";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

export function DeleteAccount() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      title: "Smazat účet",
      description:
        "Tato akce smaže váš účet. Pokračujte pouze, pokud jste si jisti.",
      recurringPayment: "Opakovaná platba bude zrušena.",
      allResultsDeleted: "Veškeré výsledky budou smazány.",
      sure: "Jste si jisti? Tuto akci nelze vrátit zpět.",
      deleting:
        "Probíhá mazání dat. Nezavírejte toto okno ani nikam neklikejte.",
      cancelChanges: "Zrušit změny",
      deleteAccount: "Smazat účet",
    },
    en: {
      title: "Delete account",
      description:
        "This action will delete your account. Continue only if you are sure.",
      recurringPayment: "Recurring payment will be cancelled.",
      allResultsDeleted: "All results will be deleted.",
      sure: "Are you sure? This action cannot be undone.",
      deleting: "Deleting data. Do not close this window or click anywhere.",
      cancelChanges: "Cancel changes",
      deleteAccount: "Delete account",
    },
  }[language];
  const { isLoading, formData, deleteAccount } = useAppContext();
  const { handleDiscardChanges } = useMenuItemsContext();
  return (
    <DialogContent className="sm:max-w-[425px]">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          deleteAccount();
        }}
        className="space-y-4"
      >
        <DialogHeader>
          <DialogTitle>{copy.title}</DialogTitle>
          <DialogDescription>{copy.description}</DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-4">
          {!isLoading ? (
            <>
              <p className="text-foreground text-sm">{copy.recurringPayment}</p>
              <p className="text-foreground text-sm">
                {copy.allResultsDeleted}
              </p>
              <p className="text-red-500 text-sm">{copy.sure}</p>
              <Input
                type="hidden"
                name="isActive"
                value={String(formData.isActive)}
              />
            </>
          ) : (
            <Alert
              role="status"
              aria-live="polite"
              tone="danger"
              className="flex items-center gap-3 px-4 py-4 text-base animate-in fade-in slide-in-from-bottom-2"
            >
              <ExclamationTriangleIcon className="size-5 shrink-0 animate-pulse" />
              <span>{copy.deleting}</span>
            </Alert>
          )}
        </div>
        <DialogFooter className="flex flex-row justify-end items-center gap-3">
          <Button
            type="button"
            variant="outline"
            disabled={isLoading}
            onClick={() => handleDiscardChanges()}
            className="ml-2"
          >
            {copy.cancelChanges}
          </Button>
          <Button
            type="submit"
            disabled={isLoading}
            variant="unstyled"
            className="relative inline-flex h-8 items-center justify-center rounded-md bg-red-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-red-700 disabled:pointer-events-none disabled:opacity-50 dark:bg-red-600 dark:text-white dark:hover:bg-red-500"
          >
            {isLoading ? (
              <>
                <span className="opacity-0">{copy.deleteAccount}</span>
                <span className="dots">
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </span>
              </>
            ) : (
              copy.deleteAccount
            )}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  );
}
